import { StyleSheet } from '@react-pdf/renderer';
import { colors } from '../../theme/colors';

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    width: '100%',
    height: 90,
    marginBottom: 24,
    borderBottom: `1px solid ${colors.neutral200}`,
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 24,
  },

  headerContainer: {
    flexDirection: 'row',
    width: '100%',
    height: 80,
    marginBottom: 24,
    borderBottom: `1px solid ${colors.neutral200}`,
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 24,
  },

  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
  },

  flexEnd: {
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  },

  flexCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  logoPlaceholder: {
    backgroundColor: colors.neutral50,
    height: 60,
    width: 121,
    borderRadius: 6,
    border: `1.2px solid ${colors.neutral200}`,
    marginBottom: 24,
  },

  logoLabel: {
    color: colors.neutral900,
    fontSize: 11,
    fontWeight: 600,
  },

  text: {
    color: colors.neutral700,
    fontSize: 12,
    fontWeight: 400,
  },

  logoWrapper: {
    width: 80,
    height: 80,
  },

  logo: {
    borderRadius: 5,
    height: 'auto',
    width: 'auto',
  },
});
